var React = require('react');

function ArrowBlockLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"m0 0h60l-17 40h-43z","fill":"#26c66a","key":0}),React.createElement("g",{"stroke":"#fff","strokeLinecap":"square","key":1},[React.createElement("path",{"d":"m36.5 20h-21","transform":"matrix(-1 0 0 -1 52 40)","key":0}),React.createElement("path",{"d":"m21 26-6-6","transform":"matrix(-1 0 0 -1 36 46)","key":1}),React.createElement("path",{"d":"m21 14-6 6","transform":"matrix(-1 0 0 -1 36 34)","key":2})])]));
}

ArrowBlockLeft.defaultProps = {"height":"40","viewBox":"0 0 60 40","width":"60"};

module.exports = ArrowBlockLeft;

ArrowBlockLeft.default = ArrowBlockLeft;
